export default {
  changeFullWidth(state, full_width) {
    state.full_width = full_width; 
  },
  suma(state) {
    state.test_count ++; 
  },
  resta(state) {
    state.test_count --; 
  },
  login(state, user_connected_id) {
    state.user_connected_id = user_connected_id;
    localStorage.setItem("ct_app_user_connected_id", state.user_connected_id);
  },
  logout(state ) {
    state.user_connected_id = null;
    localStorage.removeItem("ct_app_user_connected_id");
  }
}